@if(!readNow()){
    <span style="font-style: italic;">{{ 'progress.'+playerProgress(levelCard()) | translate }}</span>
}@else{
    {{ 'progress.'+playerProgressOnline(levelCard()) | translate }}
}
